import { render, staticRenderFns } from "./LearningCentral.vue?vue&type=template&id=b32351ca&"
import script from "./LearningCentral.vue?vue&type=script&lang=js&"
export * from "./LearningCentral.vue?vue&type=script&lang=js&"
import style0 from "./LearningCentral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports